import isEmpty from "lodash/isEmpty";

import { TextTestID } from "@/constants/TestID";
import { Text, TextTag } from "@/ui/core";
import { Box, HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs, toSentenceCase } from "@/utils/string.util";

interface SMTFoodEntryDetailsProps extends ViewWithTestID {
  foodComment?: string;
  foodDescription?: string;
  foodType?: SMTFoodType;
  isNewFood?: boolean;
}

const SMTFoodEntryDetails = ({
  foodComment,
  foodDescription,
  foodType,
  isNewFood,
  testID,
}: SMTFoodEntryDetailsProps) => {
  return (
    <HStack gap={18} testID={testID}>
      <Box width={72}>
        <TextTag text="Food" variant="informational" />
      </Box>
      <VStack flex={1} gap={12}>
        <VStack gap={2}>
          {foodType && (
            <Text testID={joinTestIDs(testID, TextTestID.Title)}>
              {toSentenceCase(foodType.toLowerCase())}
            </Text>
          )}

          {!isEmpty(foodDescription) && (
            <Text
              color={ColorToken.NeutralSecondary}
              testID={joinTestIDs(testID, TextTestID.Description)}
              variant="caption"
            >
              {foodDescription}
            </Text>
          )}

          {!isEmpty(foodComment) && (
            <Text
              color={ColorToken.NeutralSecondary}
              testID={joinTestIDs(testID, TextTestID.Comment)}
              variant="caption"
            >
              {foodComment}
            </Text>
          )}
        </VStack>
        {isNewFood && <TextTag text="New food" variant="newFood" />}
      </VStack>
    </HStack>
  );
};

export default SMTFoodEntryDetails;
export type { SMTFoodEntryDetailsProps };
